export const GET_CUSTOM_PLAYLISTS = 'customAudioPlaylist/GET_CUSTOM_PLAYLISTS';
export const SET_CUSTOM_PLAYLISTS = 'customAudioPlaylist/SET_CUSTOM_PLAYLISTS';
export const SET_CUSTOM_PLAYLISTS_LOADING =
  'customAudioPlaylist/SET_CUSTOM_PLAYLISTS_LOADING';
export const SET_CUSTOM_PLAYLISTS_ERROR =
  'customAudioPlaylist/SET_CUSTOM_PLAYLISTS_ERROR';
export const DELETE_CUSTOM_PLAYLIST =
  'customAudioPlaylist/DELETE_CUSTOM_PLAYLIST';
export const REMOVE_CUSTOM_PLAYLIST =
  'customAudioPlaylist/REMOVE_CUSTOM_PLAYLIST';
